'use strict';

const i18n = require('i18next');
const _ = require('underscore');
const Mn = require('backbone.marionette');
const Dialog = require('common/util/dialog');
const SyncStateTemplate = require('system/ui/template/sync-state.hbs');

const SyncStateView = Mn.View.extend({
    template: SyncStateTemplate,
    events: {
        'click .sync-start': 'startSync',
        'click .resync-start': 'startResync'
    },

    initialize: function() {
        _.bindAll(this, 'update');

        this.listenTo(this.model, 'change', this.update);
    },

    onRender: function() {
        this.update();
    },

    update: function() {
        const state = this.model.get('state');
        this.$('.sync-state').hide();
        this.$(`.sync-state.sync-state-${state}`).show();
    },

    startSync: function() {
        this.trigger('sync:start');
    },

    startResync: function() {
        Dialog.confirm({
            text: i18n.t('diagram:alert.resync.confirm'),
            okCallback: () => {
                this.trigger('resync:start');
            }
        });
    }
});

module.exports = SyncStateView;



// WEBPACK FOOTER //
// ./system/ui/view/sync-state.js